import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { milfordConfig } from "./data";

export default function MilfordPage() {
  return <CityPageTemplate config={milfordConfig} />;
}